import { Button } from "@somethings-ui/web";
import { Dialog, DialogContent } from "@/components/ui/dialog.tsx";

interface TrainingWelcomeModalProps {
  open: boolean;
  onAcknowledge: () => void;
}

const POINTS = [
  {
    title: "The bar at the top tracks your progress",
    body: "It shows how many messages you've sent and how many complete the level.",
  },
  {
    title: "Your progress will be saved",
    body: "You will resume where you left off in the conversation if you exit the level.",
  },
  {
    title: "If things get serious, escalate",
    body: 'Practice using "Escalate to Clinical Team" when a conversation needs a professional. It\'s safe to try here.',
  },
];

export function TrainingWelcomeModal({
  open,
  onAcknowledge,
}: TrainingWelcomeModalProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="gap-0 overflow-hidden rounded-md p-0 sm:max-w-3xl"
        hideCloseButton
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="relative flex flex-col justify-center gap-3 overflow-hidden border-b border-surfaces-divider bg-surfaces-z3 p-6">
          <img
            src="/assets/training-simulator/welcome-texture.png"
            alt=""
            aria-hidden
            className="pointer-events-none absolute -right-1 top-0 h-full max-w-none select-none"
          />
          <div className="relative z-10 flex flex-col gap-3">
            <h2 className="text-header-2 text-text-primary">
              Welcome to the Teen Simulator
            </h2>
            <p className="max-w-md text-body-1 text-text-secondary">
              In these levels you&apos;ll talk to a simulated teen, so you can
              practice and build confidence before any real conversations.
            </p>
          </div>
        </div>

        {POINTS.map((point) => (
          <div
            key={point.title}
            className="flex flex-col gap-1 border-b border-surfaces-divider p-6"
          >
            <p className="text-header-5 text-text-primary">{point.title}</p>
            <p className="text-body-1 text-text-secondary">{point.body}</p>
          </div>
        ))}

        <div className="flex justify-end p-6">
          <Button variant="primary" fullWidth={false} onClick={onAcknowledge}>
            Got it, let&apos;s start
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
